import request from '../request'
export default {
  // 订单查询
  listOrder: function (param) {
    return request.Post('v1/shop/listOrder', {
      id: param.id || ''
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }
}
